const pillars = [
  { icon: "ri-shield-user-line", title: "Security Experts", desc: "Over a decade of experience in iOS security architecture and privacy-first engineering." },
  { icon: "ri-smartphone-line", title: "iOS Native", desc: "We build exclusively for the Apple ecosystem, ensuring native performance and seamless UX." },
  { icon: "ri-team-line", title: "Dedicated Team", desc: "A close-knit team of iOS engineers, designers, and product specialists based in Slovenia." },
  { icon: "ri-code-s-slash-line", title: "Clean Code", desc: "Our codebase follows the highest standards — modular, maintainable, and well-documented." },
  { icon: "ri-trophy-line", title: "User-Centric", desc: "Every feature is driven by real user feedback and best practices in mobile UX research." },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-gray-950 py-24 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Top label */}
        <p className="text-xs font-semibold tracking-[0.3em] text-emerald-400/70 uppercase text-center mb-6">
          About Us
        </p>

        {/* Main title */}
        <h2 className="text-4xl md:text-6xl font-extrabold text-white text-center leading-tight mb-4 tracking-tight">
          Who We Are
        </h2>
        <p className="text-white/50 text-center text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
          FUSA d.o.o. is a Slovenian software company with a singular mission — to make iOS devices safer,
          faster, and smarter for everyday users around the world.
        </p>

        {/* Badges */}
        <div className="flex flex-wrap gap-4 justify-center mb-20">
          <div className="bg-white text-gray-900 text-sm font-semibold px-7 py-3 rounded-full whitespace-nowrap">
            Enhance User Experience
          </div>
          <div className="border border-white/30 text-white text-sm font-semibold px-7 py-3 rounded-full whitespace-nowrap">
            Improve Mobile Security
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="bg-gray-800/60 rounded-2xl p-6 flex flex-col gap-4 hover:bg-gray-700/60 transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-400/10">
                <i className={`${p.icon} text-emerald-400 text-xl`} />
              </div>
              <div>
                <h3 className="text-white font-bold text-sm mb-1">{p.title}</h3>
                <p className="text-white/50 text-xs leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
